import { render } from "./Portada.vue?vue&type=template&id=2de775fe&scoped=true&lang=true"
import script from "./Portada.vue?vue&type=script&lang=js"
export * from "./Portada.vue?vue&type=script&lang=js"

import "./Portada.vue?vue&type=style&index=0&id=2de775fe&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de775fe"]])

export default __exports__